import { render, staticRenderFns } from "./AgentTransactionsXLS.vue?vue&type=template&id=32229a57"
import script from "./AgentTransactionsXLS.vue?vue&type=script&lang=js"
export * from "./AgentTransactionsXLS.vue?vue&type=script&lang=js"
import style0 from "./AgentTransactionsXLS.vue?vue&type=style&index=0&id=32229a57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports